import { useEffect, useState } from "react";
import { PlaceSuggestion } from "./usePlaces.types";
import { fetchPlaceSuggestions } from "./places.service";


export const usePlacesAutocomplete = (input: string) => {
    const [suggestions, setSuggestions] = useState<PlaceSuggestion[]>([]);
    const [locationSelecting, setLocationSelecting] = useState(false);
    const [selectedPlace, setSetselectedPlace] = useState<PlaceSuggestion | undefined>(undefined)

    const reloadSuggestions = async () => {
        const data = await fetchPlaceSuggestions(input);
        setSuggestions(data)
    }


    useEffect(() => {
        if (locationSelecting) return;
        if (!input || input.length < 3 || !window.google) return;

        let cancelled = false;

        const run = async () => {
            const data = await fetchPlaceSuggestions(input);
            if (!cancelled) setSuggestions(data);
        };

        run();

        return () => {
            cancelled = true;
        };
    }, [input, locationSelecting]);

    const clear = () => setSuggestions([]);

    return { suggestions, clear, locationSelecting, setLocationSelecting, selectedPlace, setSetselectedPlace, reloadSuggestions };
};